import PricingArrowDown from "../Icons/PricingArrowDown.icon";
import PricingArrowUp from "../Icons/PricingArrowUp.icon";
import { useState } from "react";

const PricingCardFeature = ({ feature: { title, detail }, isOpen, setIsOpen }) => (
  <div className="d-flex align-items-top justify-content-flex w-100">
    <a onClick={() => setIsOpen(!isOpen)} style={{ cursor: "pointer" }}>
      <i>{isOpen ? <PricingArrowUp className="fill-primary" /> : <PricingArrowDown  className="fill-primary" />}</i>
    </a>
    <div>
      <h6 className="py-1 pl-3 mb-2">
        <a onClick={() => setIsOpen(!isOpen)} style={{ cursor: "pointer" }}>
          <strong>
            <strong>{title}</strong>
          </strong>
        </a>
      </h6>
      <p className="py-0 pl-3 mb-0" style={{ maxHeight: isOpen ? 100 : 0, overflow: "hidden", transition: "max-height 0.3s ease-in 0s" }} dangerouslySetInnerHTML={{ __html: detail }} />
    </div>
  </div>
);

const PricingCard = ({ title, price, features, details, bgColor, headerColor, icon, heading }) => {
  const [openIndex, setOpenIndex] = useState(0);
  return (
    <div className="col-12 col-md-8 mx-auto p-3 mb-5">
      <div className="card align-items-left border-0 h-100">
        <div
          className={`${bgColor} ${headerColor} w-100 px-4 py-1 rounded-top`}
        >
          <h6>
            <strong>
              <strong style={{ textTransform: "uppercase" }}>{heading}</strong>
            </strong>
          </h6>
        </div>
        <div className="row w-100 pt-4">
          <div className="col-12 col-md-6">
            <div className="px-4 pb-2">
              {icon}
              <h2 className="text-primary p-0 my-2">
                <strong>{title}</strong>
              </h2>
            </div>
            <div className="px-4">
              <h1 className="pb-0 mb-1">
                <strong>{price}</strong>
              </h1>
              <p className="ss-subtext pt-0 mt-0">(Annually, ex GST)</p>
            </div>
            <div className="align-items-center px-4 py-3">
              <a href="#pricing-enquiry">
                <button className="bg-primary text-white rounded border-0 p-2" style={{cursor: "pointer"}}>
                  Get Started!
                </button>
              </a>
            </div>
          </div>
          <div className="col-12 col-md-6">
            <div className="px-4">
              <ul className="list-style-none p-0 m-0">
                {features.map((feature, index) => (
                  <li key={index} className="mb-3">
                    <PricingCardFeature
                      feature={feature} 
                      isOpen={openIndex === index}
                      setIsOpen={(isOpen) => setOpenIndex(isOpen ? index : null)}
                    />
                  </li>
                  )
                )}
              </ul>
            </div>
          </div>
        </div>
      </div>
      <p className="ss-subtext pt-2">{details}</p>
    </div>
  );
};

export default PricingCard;



// WEBPACK FOOTER //
// ./resources/assets/js/app/Pricing/pricingCards.js